import { Subject } from 'rxjs';
import { EntityType } from '@tamalelibs/models/entity-type.model';

// below is for relationship tree node events
export enum RelationshipTreeEvents {
    CHECKED_NODE_CHANGED = 'CHECKED_NODE_CHANGED',
    EXPANDED_CHANGED = 'EXPANDED_CHANGED',
    NODE_DOUBLE_CLICKED = 'NODE_DOUBLE_CLICKED',
    NODE_SINGLE_CLICKED = 'NODE_SINGLE_CLICKED',
    CONTEXTMENU_VIEWRESEARCH = 'CONTEXTMENU_VIEWRESEARCH',
    CONTEXTMENU_SHOWNAMEFORMAT = 'CONTEXTMENU_SHOWNAMEFORMAT',
    UPDATE = 'UPDATE',
    REMOVE_ONE_RELATIONSHIP = 'REMOVE_ONE_RELATIONSHIP',
    REMOVE_MULTI_RELATIONSHIP = 'REMOVE_MULTI_RELATIONSHIP',
    ADD_ENTITY = 'ADD_ENTITY',
}

// below is for relationship tree events
export enum RelationshipTreeActions {
    RESET = 'RESET',
    CHECK_ALL = 'CHECK_ALL',
    UNCHECK_ALL = 'UNCHECK_ALL',
    SET_CHECKED_KEYS = 'SET_CHECKED_KEYS',
    REMOVE_RELATIONSHIP = 'REMOVE_RELATIONSHIP',
    CHANGE_RELATIONSHIP = 'CHANGE_RELATIONSHIP',
    ADD_RELATIONSHIP = 'ADD_RELATIONSHIP',
    EDIT_DETAILS = 'EDIT_DETAILS',
    // below is used for the dialog title, so, the value will be not same with the key
    ADD_ENTITIES = 'Add Entities',
    ADD_CONTACTS = 'Add Contacts',
    // below is used to tell the relationship tree that the checkedkeys has changed, when click all or one degree in the research screen
    CHANGE_CHECKEDKEYS = 'CHANGE_CHECKEDKEYS',
}

export enum RelationshipTreeNodeCategory {
    ENTITY = 'ENTITY',
    CONTACT = 'CONTACT',
    ENTITY_GROUP = 'ENTITY_GROUP',
    CONTACTS_GROUP = 'CONTACTS_GROUP',
    TEAM_MEMBER_GROUP = 'TEAM_MEMBER_GROUP',
    TEAMS_GROUP = 'TEAMS_GROUP',
    FORMER_EMPLOYMENT_GROUP = 'FORMER_EMPLOYMENT_GROUP',
    CURRENT_EMPLOYMENT_GROUP = 'CURRENT_EMPLOYMENT_GROUP',
}

export class RelationshipTreeNode {
    uuid: string;
    isLeaf: boolean;
    level: string;
    parentId?: string;
    nodeType: 'ENTITY' | 'RELATIONSHIP' | 'CUSTOMIZE';
    id?: string;
    name: string;
    company?: string;
    isPublic?: boolean;
    shortName: string;
    title?: string;
    type?: EntityType;
    relationshipId?: string;
    relationshipTypeName?: string;
}

export class RelationshipTreeConfig {
    nodes: RelationshipTreeNode[];
    checkedKeys: string[] = [];
    expandedKeys: string[] = [];
    showAs: 'name' | 'shortName';
    checkable?: boolean;
    expandable?: boolean;
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor() {
        this.actions$ = new Subject();
        this.events$ = new Subject();
    }
}

